import ToastNotification from './ToastNotification';
import { ToastNotificationProps, ToastNotificationValueProps } from './types';

export type { ToastNotificationProps, ToastNotificationValueProps };
export default ToastNotification;
